"use client";

import { useAppContext } from "@/context/AppContext";
import { Button, ButtonTypes } from "../Button/Button";
import type { ActivePopupContent } from "@/context/AppContext";

type PopupButtonProps = {
  children: React.ReactNode;
  btnType: ButtonTypes;
  extraClass?: string;
  ariaLabel: string;
  popupContent?: ActivePopupContent;
};
export const PopupButton = ({
  children,
  btnType,
  extraClass,
  ariaLabel,
  popupContent,
}: PopupButtonProps) => {
  const { setActivePopupContent, setopenPopup } = useAppContext();

  return (
    <Button
      type={btnType}
      href=""
      target=""
      className={extraClass}
      aria-label={ariaLabel}
      aria-haspopup="dialog"
      onClick={() => {
        setActivePopupContent(popupContent ?? null);
        setopenPopup(true);
      }}
    >
      {children}
    </Button>
  );
};
